import {Component, ViewChild} from "@angular/core";
import {EditGridComponent} from "../../../framework/entity/edit/edit-grid/edit-grid.component";
import {EntityData, field, identifier, ReportModel} from "@fedeltapointofsale/data-client";
import {DiscountSearchPageComponent} from "../discount-search-page/discount-search-page.component";

export class DiscountReportSelectionData extends EntityData<DiscountReportSelectionData> {
    @identifier discountId: number;
    @field name: string;
}
@Component({
    selector: "wbo-discount-report-selection",
    templateUrl: "./discount-report-selection-control.component.html"
})

export class DiscountReportSelectionControlComponent {
    DiscountSearchPageComponent = DiscountSearchPageComponent;

    fieldName: string = "discounts";

    @ViewChild(EditGridComponent) editGridComponent: EditGridComponent;

    constructor(public model: ReportModel<any>) {
    }

    addFromDiscount(data: any[]): void {
        data.forEach((item) => {
            if (!this.model.data[this.fieldName].find((discount: any) => discount.discountId === item.discountId)) {
                const index: number = this.editGridComponent.addRow(item) - 1;
            }
        });
    }

}
